// System Settings - Global API Tokens Configuration
// This file sets up default API tokens for all users

const SYSTEM_SETTINGS = {
  // OpenAI Configuration
  openai_key: "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",
  gpt_model: "gpt-4o",
  
  // Azure Speech Service Configuration
  azure_token: "E0nyA9DSELJtJqiYtNRsP9IzJysTaUBRmlEDHLddH2FD3KJCwqezJQQJ99BGACYeBjFXJ3w3AAAYACOGzo99",
  azure_region: "eastus", // Common region for Azure Speech Service
  azure_language: "en-US"
}

// Function to initialize system settings in localStorage
function initializeSystemSettings() {
  // Only set if not already configured by user
  Object.keys(SYSTEM_SETTINGS).forEach(key => {
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, SYSTEM_SETTINGS[key])
      // Settings configured silently for security
    } else {
      // User settings preserved silently
    }
  })
  
  // System ready
}

// Function to reset all settings to system defaults
function resetToSystemDefaults() {
  console.log('🔄 Resetting to system defaults...')
  
  Object.keys(SYSTEM_SETTINGS).forEach(key => {
    localStorage.setItem(key, SYSTEM_SETTINGS[key])
    console.log(`✅ Reset ${key}`)
  })
  
  console.log('✅ All settings reset to system defaults')
  
  // Reload the page to apply changes
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
}

// Function to check if system settings are configured
function isSystemConfigured() {
  return Object.keys(SYSTEM_SETTINGS).every(key => 
    localStorage.getItem(key) !== null && localStorage.getItem(key) !== ""
  )
}

// Function to get system setting value
function getSystemSetting(key) {
  return localStorage.getItem(key) || SYSTEM_SETTINGS[key]
}

// Auto-initialize on import (for browser environments)
if (typeof window !== 'undefined') {
  // Run initialization after a short delay to ensure DOM is ready
  setTimeout(() => {
    initializeSystemSettings()
  }, 100)
}

export default {
  initializeSystemSettings,
  resetToSystemDefaults,
  isSystemConfigured,
  getSystemSetting,
  SYSTEM_SETTINGS
}
